<template>
  <div>
    <h4>Hi {{firstName}}</h4>
    <p>We have updated our terms and our data policy. Please take a moment to let us know that you agree to our updated terms to continue use ClassForKids.</p>
    <p>Your ClassForKids experience isn't changing. We are giving you better ways to access your data and understand how it is used.</p>
  </div>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    props: {
      firstName: {
        type:String,
        required:true
      }
    }
}
</script>

<style>

</style>
